import { render, staticRenderFns } from "./QuestionPopover.vue?vue&type=template&id=2e38e4fb&scoped=true"
import script from "./QuestionPopover.vue?vue&type=script&lang=ts"
export * from "./QuestionPopover.vue?vue&type=script&lang=ts"
import style0 from "./QuestionPopover.vue?vue&type=style&index=0&id=2e38e4fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38e4fb",
  null
  
)

export default component.exports